export default __webpack_public_path__ + "static/media/snake.417a179e.png";